import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

export const useUpdateCustomMetricsDataSourceMutation = () => {
  return useMutation({
    mutationFn: apiClient.workloadOptimization.updateCustomMetricsDataSource,
  });
};
